export function dateComparator(attribute, ascending = true) {
  return (first, second) => {
    if (ascending) {
      return first[attribute] > second[attribute] ? 1 : -1
    } else {
      return first[attribute] < second[attribute] ? 1 : -1
    }
  }
}
